import React from "react";
import QuickLinksEmbedded from "../../../components/QuickLinksEmbedded";
import type { SearchInputProps } from "../../../components/SearchInput/SearchInput";
import QuickLinks from "../../../components/common/QuickLinks";
import type { QuickLinksItemProps } from "../../../components/common/QuickLinksItem";
import { Colours } from "../../../utils/colours";
import { mapPromotedItemsToQuickLink } from "../../../utils/mappers";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface SectionQuickLinksProps {
	heading?: string;
	items: QuickLinksItemProps[];
	minItems: number;
	maxItems: number;
	embedded?: boolean;
	withSearch?: SearchInputProps;
	theme: "primary" | "alternative";
	isHomePage?: boolean;
}

export const getSectionQuickLinksProps = (
	{
		promotedLinks,
		field_min_items_to_display,
		field_max_items_to_display,
	}: Queries.SectionDataFragment,
	theme?: "primary" | "alternative",
	heading?: string,
	isHomePage?: boolean,
): SectionQuickLinksProps => ({
	items: promotedLinks.map(mapPromotedItemsToQuickLink),
	minItems: field_min_items_to_display,
	maxItems: field_max_items_to_display,
	theme,
	heading,
	isHomePage,
});
export const SectionQuickLinks: React.FC<SectionQuickLinksProps> = ({
	items,
	minItems,
	maxItems,
	isHomePage,
}) => {
	items.sort((a, b) =>
		a.priority > b.priority ? -1 : a.priority < b.priority ? 1 : 0,
	);
	if (items.length < minItems || items.length > maxItems) {
		// Adding noise to builds, turn on if needed
		// console.warn(
		//     `SectionQuickLinks not displaying as incorrect number of items provided: ${items.length}`
		// );
		return null;
	}
	return (
		<WrappedSection
			sectionName="SectionQuickLinks"
			sectionColour={Colours.SANDY_FUR}
			isHomePage={isHomePage}
		>
			<QuickLinks items={items} isHomePage={isHomePage} />
		</WrappedSection>
	);
};

export const SectionQuickLinksEmbedded: React.FC<SectionQuickLinksProps> = ({
	items,
	minItems,
	maxItems,
	withSearch,
	theme,
	heading,
}) => {
	if (items.length < minItems || items.length > maxItems) {
		// Adding noise to builds, turn on if needed
		// console.warn(
		//     `SectionQuickLinks not displaying as incorrect number of items provided: ${items.length}`
		// );
		return null;
	}

	return (
		<WrappedSection
			sectionName="SectionQuickLinksEmbedded"
			sectionColour={
				theme === "primary" ? Colours.SUNSHINE_YELLOW : Colours.SANDY_FUR
			}
		>
			<QuickLinksEmbedded
				title={heading}
				items={items}
				withSearch={withSearch}
				theme={theme}
			/>
		</WrappedSection>
	);
};

export default SectionQuickLinksEmbedded;
